module.exports = __webpack_public_path__ + "img/img-4.b2f77390.jpg";